import React, {Component} from 'react';
import {Redirect} from "react-router-dom";
import auth from "../../data/auth";

class CheckPermission extends Component {
    constructor(){
        super();
        this.state = {
            access: {
                permission: true,
                session: true
            }
        }
    }

    async componentDidMount(){
        await auth.checkPermissionView(this.props.access).then(access =>{
            this.setState({access});
        }).catch();
    }

    render() {
        if(!this.state.access.permission && this.state.access.session){
            return <Redirect to='/access-denied'/>;
        }else if(!this.state.access.permission && !this.state.access.session){
            return <Redirect to='/login'/>;
        }else{
            return null;
        }
    }
}
export default CheckPermission;



// WEBPACK FOOTER //
// ./src/components/extras/CheckPermission.js